<script setup lang="ts">
import { ref, onMounted, toRefs, computed, watch } from 'vue';
import { RouterLink, RouterView, useRoute } from 'vue-router';
import { debounce } from '@/utils/index';
const emit = defineEmits([
  'input',
  'blur',
  'change',
  'update:modelValue',
  'search',
]);

const props = defineProps({
  modelValue: [String, Number],
  placeholder: { type: String, default: '请输入内容' },
  showSearchIcon: { type: Boolean, default: false }, //是否显示搜索图标
  width: { type: Number, default: 180 },
  height: { type: Number, default: 28 },
  fontSize: { type: Number, default: 12 },
  maxlength: { type: Number, default: 99999 },
  disabled: { type: Boolean, default: false },
  type: { type: String, default: 'text' },
  isShowFocused: { type: Boolean, default: false }, //聚焦时边框是否变颜色
});

const {
  placeholder,
  showSearchIcon,
  width,
  height,
  fontSize,
  maxlength,
  disabled,
  type,
  isShowFocused,
} = toRefs(props);

const searchValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const isFocused = ref(false);

const inputWidth = computed(() => {
  return showSearchIcon.value
    ? Number(width.value) - 48
    : Number(width.value) - 28;
});

const inputStyle = ref({
  width: inputWidth.value + 'px',
  '--placeholder-font-size': fontSize.value + 'px', // 默认 placeholder 字体大小
});

const handleFocus = () => {
  isFocused.value = true;
};
const handleBlur = () => {
  isFocused.value = false;
  emit('blur', searchValue.value);
};
const handleChange = () => {
  emit('change', searchValue.value);
};

//搜索框输入
const hangdleInput = debounce((e: any) => {
  searchValue.value = e.target.value;
  emit('input', e.target.value);
}, 500);

// 回车搜索
const handleEnter = () => {
  emit('search', searchValue.value);
};

// 点击搜索图标
const handleSearchClick = () => {
  emit('search', searchValue.value);
};
</script>

<template>
  <div
    class="fr-ac-jsb search-box"
    :style="{ width: width + 'px', height: height + 'px' }"
    :class="{
      focused: isFocused && (showSearchIcon || isShowFocused),
      opa4: disabled,
    }"
  >
    <input
      class="custom-input"
      :style="inputStyle"
      :value="searchValue"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      @input="hangdleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="handleChange"
      @keyup.enter="handleEnter"
    />
    <img
      class="mr-14 w-12 h-12 ml-8 pointer"
      v-show="showSearchIcon"
      src="@/assets/images/home/icon_search1.png"
      alt=""
      @click="handleSearchClick"
    />
  </div>
</template>

<style lang="scss" scoped>
.search-box {
  height: 28px;
  border-radius: var(--border-radius);
  padding: 0 14px;
  background: var(--input-bg-color);

  .custom-input {
    /* 使用 CSS 变量 */
    font-size: var(--placeholder-font-size);
  }

  .custom-input::placeholder {
    color: var(--input-placeholder-color);
    font-size: var(--placeholder-font-size);
  }
}

.focused::before {
  border-radius: var(--border-radius);
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid transparent;
  background: var(--bg-color-primary);
  /*background: linear-gradient(
      90deg,
      rgba(152, 104, 254, 1),
      rgba(55, 133, 255, 1),
      rgba(40, 207, 181, 1)
    )
    border-box;*/
  mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  /* 兼容 WebKit 浏览器 */
  mask-composite: exclude;
  /* 裁剪边框图像 */
  pointer-events: none;
  /* 确保伪元素不影响交互 */
}
</style>
